import * as React from "react";
import "./BooksSidebar.css";
import { LibraryCard } from "../../../types/LibraryCard";
import BookSection from "./BookSection/BookSection";
import { useMediaQuery } from "react-responsive";

export enum Sections {
	WantRead = "WantRead",
	AlreadyRead = "AlreadyRead",
	ReadNow = "ReadNow",
	All = "All",
}

interface Props {
	wantRead: LibraryCard[];
	alreadyRead: LibraryCard[];
	readNow: LibraryCard[];
	onCardSelect?: (bookId: number) => void;
	onlySection?: Sections;
	selectedBookId?: number;
	onChangeSection?: (type: Sections) => void;
}

interface Section {
	name: string;
	type: Sections;
	cards: LibraryCard[];
	emptyText: string;
}

export const BooksSidebar: React.FunctionComponent<Props> = (props) => {
	const isMobile = useMediaQuery({ maxWidth: 600 });

	const sections: Section[] = React.useMemo(() => {
		return [
			{
				name: "📆 Этот месяц",
				type: Sections.ReadNow,
				cards: props.readNow,
				emptyText: "Нет книг, запланированных для чтения в этом месяце",
			},
			{
				name: "🕑 Хочу прочитать",
				type: Sections.WantRead,
				cards: props.wantRead,
				emptyText: "Добавьте книги, которые вы планируете прочитать",
			},
			{
				name: "✅ Вы прочли ранее",
				type: Sections.AlreadyRead,
				cards: props.alreadyRead,
				emptyText: "Добавьте книги, которые вы прочитали",
			},
			{
				name: "Все",
				type: Sections.All,
				cards: [...props.readNow, ...props.wantRead, ...props.alreadyRead],
				emptyText: ""
			}
		];
	}, [props.alreadyRead, props.wantRead]);

	if (isMobile) {
		const section = sections.find(
			(section) => section.type === props.onlySection
		);

		return (
			<BookSection
				sectionName={section.name}
				books={section.cards}
				onCardSelect={props.onCardSelect}
				emptyText={section.emptyText}
				selectedBookId={props.selectedBookId}
				type={section.type}
				onChangeSection={props.onChangeSection}
			/>
		);
	}

	return (
		<div className="books-sidebar">
			{sections.filter(section => section.type !== Sections.All).map((section) => {
				return (
					<BookSection
						sectionName={section.name}
						books={section.cards}
						onCardSelect={props.onCardSelect}
						emptyText={section.emptyText}
						selectedBookId={props.selectedBookId}
					/>
				);
			})}
		</div>
	);
};

export default BooksSidebar;
